/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';

import PropTypes from 'prop-types';

// COMPONENTS
import Switch from '../Switch/Switch';

import styles from './Alert.module.scss';

const options1 = require('./imgs/options-1.svg');
const options2 = require('./imgs/options-2.svg');
const details = require('./imgs/details-asset.png');

const downIcon = require('./imgs/icons/down-icon.svg');

class Alert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
      enabled: false,
    };
  }

  render() {
    const { id } = this.props;
    const { expanded, enabled } = this.state;
    return (
      <div className={styles.alertWrapper}>
        <div className={styles.alertContainer}>
          {/* ALERT HEADER */}
          <div className={styles.alertHeader}>
            <div>
              <span>02.04.20</span>
              <p>NOTIFY ME IF:</p>
            </div>
            <div>
              <p>{enabled ? 'Enabled' : 'Disabled'}</p>
              <Switch onChange={(value) => this.setState({ enabled: value })} />
            </div>
          </div>
          {/* ALERTS MAIN OPTIONS */}
          <img className={styles.mainOptions} alt="options" src={id === 1 ? options1 : options2} />
          {/* ALERTS DROPDOWN OPTIONS */}
          <div className={styles.dropdownOptionsWrapper}>
            <div
              onClick={() => this.setState({ expanded: !expanded })}
              className={styles.dropdownOptionsHeader}
            >
              <p>Details</p>
              <img
                className={expanded ? styles.expanded : null}
                alt="arrow"
                src={downIcon}
              />
            </div>
            <img
              className={[
                styles.details,
                expanded ? styles.expandedDetails : null,
              ].join(' ')}
              alt="details"
              src={details}
            />
          </div>
        </div>
      </div>
    );
  }
}

Alert.propTypes = {
  id: PropTypes.number.isRequired,
};

export default Alert;
